/**
 * Filters and returns a list of unique counties by region from the provided intersecting counties.
 *
 * This function ensures that the resulting list contains counties with unique region codes
 * and excludes the county specified by `countyName` and `regionCode`.
 *
 */
import { IntersectingCountyNodeFields } from '../../../generated/graphql';

export const getUniqueCountiesByRegion = (
  countyName: string,
  regionCode: string,
  intersectingCounties: IntersectingCountyNodeFields[],
) => {
  return intersectingCounties.reduce<IntersectingCountyNodeFields[]>((acc, county) => {
    if (
      !acc.some(item => item.region.regionCode === county.region.regionCode) &&
      (county.name !== countyName || county.region.regionCode !== regionCode)
    ) {
      acc.push(county);
    }
    return acc;
  }, []);
};
